import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_BUSINESS_FILE](state, payload) {
    state.file = payload;
  },
  [MutationsType.SET_BUSINESS_FILES](state, payload) {
    state.files = payload;
  },
  [MutationsType.ADD_BUSINESS_FILE](state, payload) {
    state.files.unshift(payload);
  },
  [MutationsType.UPDATE_BUSINESS_FILE](state, payload) {
    if (!state.files) return;

    let ind = state.files.findIndex((file) => file.id === payload.id);
    if (ind >= 0) Vue.set(state.files, ind, { ...state.files[ind], ...payload });
  },
  [MutationsType.DELETE_BUSINESS_FILE](state, payload) {
    let ind = state.files.findIndex((file) => file.id === payload.id);
    if (ind >= 0) Vue.delete(state.files, ind);
  },
};
